export const environment = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  appEnv: process.env.REACT_APP_ENV,
  gaTrackingId: process.env.REACT_APP_GA_TRACKING_ID,
};
